export default "__VITE_ASSET__BEjYV77v__"